import WrapperLayout from 'layouts/WrapperLayout';
import { useTranslation } from 'react-i18next';
import DetailRoomContainer from 'containers/DetailRoomContainer';

type Props = {};

export default function DetailRoomPage({}: Props) {
  const { t } = useTranslation();

  return (
    <WrapperLayout title={t('title.room-information')}>
      <DetailRoomContainer />
    </WrapperLayout>
  );
}
